import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  isDevMode,
  provideAppInitializer,
  provideZoneChangeDetection
} from '@angular/core';
import {GlobalErrorHandlerService} from './services/global-error-handler.service';
import {routes} from './app.routes';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from "@angular/common/http";
import {environment} from '../environments/environment';
import {
  addSvgIcons,
  AUTH_CONFIG,
  AuthConfig,
  AuthenticationInterceptor,
  AuthService,
  CustomAuthService,
  LoyaltyCurrencyPipe,
  TranslocoHttpLoader,
  TRANSLOCO_LOADER_CONFIG
} from 'shared-lib';
import {provideAnimations} from '@angular/platform-browser/animations';
import {provideTransloco, TranslocoService} from '@jsverse/transloco';
import {DomSanitizer} from '@angular/platform-browser';
import {MatIconRegistry} from '@angular/material/icon';
import {provideRouter} from '@angular/router';
import {lastValueFrom} from 'rxjs';
import {CurrencyPipe} from '@angular/common';


export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({eventCoalescing: true}),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    {provide: 'environment', useValue: environment},
    {
      provide: AuthService,
      useClass: CustomAuthService
    }, {
      provide: ErrorHandler,
      useClass: GlobalErrorHandlerService
    }, {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    {
      provide: AUTH_CONFIG,
      useValue: {
        publicEndpoints: [`${environment.apiUrl}/auth/reset-password`],
        notAuthenticatedRedirectRoute: "/mcards/authentication",
        authenticatedRedirectRoute: "/"
      } as AuthConfig
    },
    provideAnimations(),
    provideTransloco({
      config: {
        availableLangs: ['en'], // ✅ Ensure the same languages as in the library
        defaultLang: 'en',
        reRenderOnLangChange: true,
        prodMode: !isDevMode(),
      },
      loader: TranslocoHttpLoader, // ✅ Use the custom loader from your library
    }),
    {
      provide: TRANSLOCO_LOADER_CONFIG,
      useValue: {
        version: environment.version
      }
    },
    provideAppInitializer(() => {
      const translocoService = inject(TranslocoService);
      return lastValueFrom(translocoService.load(translocoService.getDefaultLang()))
    }),
    provideAppInitializer(() => {
      const domSanitizer = inject(DomSanitizer);
      const iconRegistry = inject(MatIconRegistry);
      // Register icons
      addSvgIcons(iconRegistry, domSanitizer, ['arrow-down-dark', 'magnifying-glass', 'check', 'seal-check', 'arrow-circle-up',
        'arrow-circle-down', 'seal-check-purple']);
    }),
    CurrencyPipe,
    LoyaltyCurrencyPipe
  ]
};
